module.exports = __webpack_public_path__ + "static/media/icon_9.6b00c665.png";